namespace Matrix.Rebalancer {
    export class SummaryViewInstanceColumns {
        static columnsKey = 'Rebalancer.SummaryViewInstance';
    }
}
